import { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import DesktopPageHeader from "../../../../components/DesktopPageHeader";
import ChatViewer from "../../../../components/ChatViewer";
import { useChat } from "../../../../hooks/useChat";
import { useRestoUsers } from "../../../../hooks/useRestoUsers";
import { useUser } from "../../../../hooks/useUser";

export const ChatTab = ({ resto }) => {
    const history = useHistory();
    const location = useLocation();
    const { isOwner } = useUser();
    const { chatMessages, refreshBeforeSend, sendAll, sendSingleMessage, markReadMessages } = useChat();
    const { hostResto, getAllRestoHost} = useRestoUsers()
    const [restoName, setRestoName] = useState("")
    const [avatar, setAvatar] = useState("")
    const [restoAddress, setRestoAddress] = useState("")
    const [restoId, setRestoId] = useState("")
    const chatRef = useRef(null);

    useEffect(() => {
        refreshBeforeSend();
        getAllRestoHost();
    }, [])

    useEffect(() => {
        if (resto) {
            setRestoId(resto?._id)
            setRestoName(resto?.name);
            setRestoAddress(resto?.address)
            setAvatar(resto?.brand)
        }
    }, [resto])

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const mentionHostId = params.get("chatMention");
        if (!mentionHostId || !hostResto?.length) return;

        const targetHost = hostResto.find(
            (host) => String(host?._id || host?.id || "") === String(mentionHostId)
        );
        if (!targetHost?.name) return;

        chatRef.current?.insertMentionExtern(targetHost.name);

        params.delete("chatMention");
        history.replace({ pathname: location.pathname, search: params.toString() });
    }, [history, location.pathname, location.search, hostResto]);

    
    const handleSend = useCallback((payload) => {
        const users = Array.from(
            new Set((payload?.mentions || []).map((e) => String(e.value)))
        );
        const message = payload?.message || "";
        const isAll = users.includes("ALL_USERS");
        const extraPayload = isOwner && restoId ? { restoId } : {};
        console.log("[ChatTab] handleSend", {
            users,
            message,
            isAll,
            mentions: payload?.mentions || [],
            locationSearch: location.search,
            extraPayload,
        });
        if (isAll) {
            sendAll(message, [], null, extraPayload);
        } else {
            sendSingleMessage(message, users, null, extraPayload)
        } 
    }, [isOwner, location.search, restoId, sendAll, sendSingleMessage]);

    const handleMarkRead = useCallback(() => {
        markReadMessages();
    }, [markReadMessages]);

    return (
        <DesktopContainer>
            <DesktopPageHeader img={avatar} alt={restoName} />
            <ChatViewer
                ref={chatRef}
                messages={chatMessages}
                type="resto"
                onSend={handleSend}
                users={(hostResto || [])?.map(e => ({label: e.name, value: e._id}))}
                heightTab={window.innerHeight}
                onMark={handleMarkRead}
            />
        </DesktopContainer>
    );
}


const DesktopContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
